export default __webpack_public_path__ + "static/media/facebook.65469366.svg";